module.exports = __webpack_public_path__ + "static/media/icon__quotes.1fbb8d0c.svg";